(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsWidgets(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsWidgets(
            RivalIQ.enums
        );
    }

    function enumsWidgets(exports) {
        exports.widgetTypes = {
            DEPRECATION: 'deprecation',
            LIMITATION: 'limitation',
            PAID_REACH_NOTIFICATION: 'paid_reach_notification',
            ADDITIONAL_AUTHORIZATION: 'additional_authorization',
            FB_ADS_TOKEN_REQUEST: 'fb-ads-token-request',
            INSTAGRAM_PROMOTED_POSTS_LOADING: 'instagram-ads-loading',
            INSTAGRAM_PROMOTED_POSTS_TOKEN_REQUEST: 'instagram-ads-token-request',
            INSTAGRAM_PROMOTED_POSTS_ACCESS_REVOKED: 'instagram-ads-access-revoked',
            METRIC: 'metric',
            METRIC_PROGRESS_BAR: 'metric_progress_bar',
            METRIC_SUMMARY: 'metric_summary',
            METRIC_PIE_CHART_BREAKOUT: 'metric_pie_chart_breakout',
            METRIC_BAR_CHART_BREAKOUT: 'metric_bar_chart_breakout',
            METRIC_PERCENTAGE: 'metric_percentage',
            METRIC_LEGEND: 'metric_legend',
            METRIC_PIE_CHART: 'metric_pie_chart',
            METRIC_STACKED_BAR_CHART: 'metric_stacked_bar_chart',
            METRIC_LINE_CHART: 'metric_line_chart',
            METRIC_TRENDS_LINE_CHART: 'metric_trends_line_chart',
            METRIC_GROUPED_BAR_CHART: 'metric_grouped_bar_chart',
            METRIC_SPARKLINE_CHART: 'metric_sparkline_chart',
            METRIC_DISTRIBUTION_CHART: 'metric_distribution_chart',
            METRIC_CHARTS: 'metric_charts',
            METRIC_TABLE: 'metric_table',
            METRIC_TABLE_SUMMARIZED: 'metric_table_summarized',
            METRIC_TABLE_VERTICAL: 'metric_table_vertical',
            COMPANY_TABLE: 'company_table',
            COMPANY_PIE_CHART: 'company_pie_chart',
            FOCUS_COMPANY_PIE_CHART: 'focus_company_pie_chart',
            COMPANY_METRIC_SUMMARY: 'company_metric_summary',
            FOCUS_COMPANY_GLANCE: 'focus_company_glance',
            // LEGACY CHART ADAPTIONS
            METRIC_XY_CHART: 'metric_xy_chart',
            METRIC_BAR_CHART: 'metric_bar_chart',
            METRIC_BAR_CHART_WITH_CHANGE: 'metric_bar_chart_with_change',
            METRIC_COMPANY_LINE_CHART: 'metric_company_line_chart',
            FOCUS_COMPANY_METRIC_LINE_CHART: 'focus_company_metric_line_chart',
            SECTION_HEADER: 'section_header',

            GLANCE: 'glance',
            LANDSCAPE_GLANCE: 'landscape_glance',

            METRIC_HORIZONTAL_BAR_CHART: 'metric_horizontal_bar_chart',
            METRIC_TIME_CHART: 'metric_time_chart',
            METRIC_DOT_CHART: 'metric_dot_chart',
            METRIC_TABLE_CHART: 'metric_table_chart',

            SOCIAL_CHANNEL_MATRIX_OVERVIEW: 'matrix_overview',
            SOCIAL_CHANNEL_MATRIX: 'matrix',
            ALERTS: 'alerts',
            REPORT_PICKER: 'report_picker',
            SCHEDULED_REPORTS: 'scheduled_reports',
            REPORT_CENTER: 'report_center',

            MENTIONS_BY_COMPANY: 'mentions_by_company',
            MENTIONS_BY_MENTIONER: 'mentions_by_mentioner',
            MENTIONS: 'mentions',
            MENTIONS_METRIC_TABLE: 'mentions_metric_table',

            INSIGHTS_DEMOGRAPHICS: 'insights_demographics',
            INSIGHTS_PROFILE_OVERVIEW: 'insights_profile_overview',

            ADS_INSIGHTS_AD_OBJECT_TABLE: 'ads_insights_ad_object_table',
            ADS_INSIGHTS_AD_OBJECTS_ANALYSIS: 'ads_insights_ad_objects_analysis',
            ADS_INSIGHTS_GLANCE: 'ads_insights_glance',
            ADS_INSIGHTS_METRIC: 'ads_insights_metric',
            ADS_INSIGHTS_NO_RESULTS: 'ads_insights_no_results',

            DISCOVERY_GLANCE: 'discovery_glance',
            DISCOVERY_METRIC: 'discovery_metric',
            DISCOVERY_INFLUENCER_TABLE: 'discovery_influencer_table',
            DISCOVERY_DIMENSION_ANALYSIS: 'discovery_dimension_analysis',
            DISCOVERY_PIE_TABLE: 'discovery_pie_table',
            DISCOVERY_SUMMARY_TABLE: 'discovery_summary_table',
            DISCOVERY_POST_TABLE: 'discovery_post_table',

            FB_INSIGHTS_POSTS: 'fb_insights_posts',
            FB_INSIGHTS_PAGE_FANS: 'fb_insights_page_fans',
            FB_INSIGHTS_PAGE_VIEWS: 'fb_insights_page_views',
            FB_INSIGHTS_PAGE_CONSUMPTIONS: 'fb_insights_page_consumptions',
            FB_INSIGHTS_IMPRESSIONS_REACH: 'fb_insights_impressions_reach',
            FB_INSIGHTS_PAGE_REACH_GENDER: 'fb_insights_page_reach_gender',
            FB_INSIGHTS_PAGE_REACH_AGE: 'fb_insights_page_reach_age',
            INSIGHTS_AGE_GENDER_DISTRIBUTION: 'insights_age_gender_distribution',
            FB_INSIGHTS_POST_DETAILS: 'fb_insights_post_details',
            FB_INSIGHTS_REEL_DETAILS: 'fb_insights_reel_details',
            FB_INSIGHTS_POST_AT_A_GLANCE: 'fb_insights_post_at_a_glance',
            FB_INSIGHTS_REEL_AT_A_GLANCE: 'fb_insights_reel_at_a_glance',
            FB_INISGHTS_POST_REACH_AND_IMPRESSIONS: 'fb_insights_post_reach_and_impressions',
            FB_INSIGHTS_POST_ENGAGEMENT_SUMMARY: 'fb_insights_post_engagement_summary',
            FB_INSIGHTS_POST_SOCIAL_ENGAGEMENT: 'fb_insights_post_social_engagement',
            FB_INSIGHTS_REEL_SOCIAL_ENGAGEMENT: 'fb_insights_reel_social_engagement',
            FB_INSIGHTS_POST_SOCIAL_ENGAGEMENT_BREAKDOWN: 'fb_insights_post_social_engagement_breakdown',
            FB_INSIGHTS_POST_REACTIONS: 'fb_insights_post_reactions',
            FB_INSIGHTS_REEL_REACTIONS: 'fb_insights_reel_reactions',
            FB_INSIGHTS_POST_INSIGHTS_CONSUMPTION: 'fb_insights_post_insights_consumption',
            FB_INSIGHTS_POST_ADS_CONSUMPTION: 'fb_insights_post_ads_consumption',
            FB_INSIGHTS_POST_VIDEO_DETAILS: 'fb_insights_post_video_details',
            FB_INSIGHTS_VIDEO_RETENTION_CHART: 'fb_insights_post_retention_chart',
            FB_INSIGHTS_VIDEO_VIEWS: 'fb_insights_video_views',
            FB_INSIGHTS_PAGE_FANS_LOCATIONS: 'fb_insights_page_fans_locations',
            FB_INSIGHTS_PAGE_IMPRESSIONS_AND_REACH_LOCATIONS: 'fb_insights_page_impressions_and_reach_locations',
            TWITTER_INSIGHTS_POSTS: 'twitter_analytics_posts',

            INSTAGRAM_INSIGHTS_PROFILE_ANALYTICS: 'instagram_insights_profile_analytics',
            METRIC_CHANGES: 'metric_changes',
            TWITTER_INSIGHTS_FOLLOWERS: 'twitter_insights_followers',
            INSTAGRAM_INSIGHTS_FOLLOWERS: 'instagram_insights_followers',
            INSTAGRAM_INSIGHTS_FOLLOWER_AGE_GENDER: 'instagram_insights_follower_age_gender',
            INSTAGRAM_INSIGHTS_FOLLOWER_LOCATIONS: 'instagram_insights_follower_locations',
            INSTAGRAM_INSIGHTS_FOLLOWER_ONLINE_TIMES: 'instagram_insights_follower_online_times',
            FOLLOWER_ONLINE_TIMES: 'follower_online_times',
            LABELED_METRIC_LINE_CHART: 'labeled_metric_line_chart',
            GLANCE_METRIC_SUMMARY: 'glance_metric_summary',
            METRIC_PROFILE_ENGAGEMENTS_STACKED_BAR_CHART: 'metric_profile_engagements_stacked_bar_chart',

            INSTAGRAM_INSIGHTS_REACH: 'instagram_insights_reach',
            INSTAGRAM_INSIGHTS_IMPRESSIONS: 'instagram_insights_impressions',
            INSTAGRAM_INSIGHTS_METRIC: 'instagram_insights_metric',
            INSTAGRAM_INSIGHTS_STORIES_AT_A_GLANCE: 'instagram_insights_stories_at_a_glance',
            INSTAGRAM_INSIGHTS_STORYDAY_AT_A_GLANCE: 'instagram_insights_storyday_at_a_glance',
            INSIGHTS_BY_TYPE: 'insights_by_type',
            INSIGHTS_BY_TYPE_TABLE: 'insights_by_type_table',
            INSIGHTS_MEDIA: 'insights_table',
            INSTAGRAM_INSIGHTS_POSTS: 'instagram_insights_posts',
            INSTAGRAM_INSIGHTS_STORYDAYS: 'instagram_insights_storydays',
            INSTAGRAM_INSIGHTS_STORIES: 'instagram_insights_stories',
            INSIGHTS_POSTS_AT_A_GLANCE: 'insights_posts_at_a_glance',
            INSIGHTS_TIME_USAGE: 'insights_time_usage',
            INSIGHTS_HASHTAGS_TABLE: 'insights_hashtags_table',
            INSIGHTS_HASHTAGS: 'insights_hashtags',
            INSIGHTS_POST_TAGS_TABLE: 'insights_post_tags_table',
            INSIGHTS_POST_TAGS: 'insights_post_tags',
            INSIGHTS_KEYWORDS_TABLE: 'insights_keywords_table',
            INSIGHTS_KEYWORDS: 'insights_keywords',
            INSIGHTS_TIME_USAGE_LINE_CHART: 'insights_time_usage_line_chart',
            INSTAGRAM_INSIGHTS_STORIES_RETENTION_RATE: 'instagram_insights_stories_retention_rate',
            INSTAGRAM_INSIGHTS_STORIES_RETENTION_RATE_BAR_CHART: 'instagram_insights_stories_retention_rate_bar_chart',
            INSTAGRAM_INSIGHTS_STORIES_REACH: 'instagram_insights_stories_reach',
            INSIGHTS_METRIC_BAR_CHART: 'instagram_insights_metric_bar_chart',
            INSIGHTS_POSTS_ACTIVITY_IMPRESSIONS: 'instagram_insights_posts_activity_impressions',
            INSTAGRAM_INSIGHTS_STORY_DAY_REACH_IMPRESSIONS: 'instagram_insights_story_day_reach_impressions',
            INSTAGRAM_INSIGHTS_STORY_DAY_RETENTION_RATE: 'instagram_insights_story_day_retention_rate',
            INSTAGRAM_INSIGHTS_STORY_ORDER_LINE_CHART: 'instagram_insights_story_order_line_chart',

            LI_INSIGHTS_UPDATES: 'li_insights_updates',
            LI_INSIGHTS_PROFILE_ANALYTICS: 'li_insights_profile_analytics',
            LI_INSIGHTS_FOLLOWERS: 'li_insights_followers',
            LI_INSIGHTS_FOLLOWER_LOCATIONS: 'li_insights_follower_locations',
            LI_INSIGHTS_FOLLOWER_DEMOGRAPHICS: 'li_insights_follower_demographics',
            LI_ENGAGEMENT_LINE_CHART: 'li_insights_engagement_line_chart',
            LI_INSIGHTS_POST_IMPRESSIONS_PER_REACH: 'li_insights_post_impressions_per_reach',
            LI_INSIGHTS_POST_ENGAGEMENTS: 'li_insights_post_engagements',

            CONNECTED_PAGES_TABLE: 'connected_pages_table',

            INVOICES: 'invoices',
            METRICS_EXPLORER: 'metrics_explorer',

            USER: 'user',
            CSM_DETAILS: 'csm_details',
            USER_PROFILE_MANAGEMENT: 'user_profile_management',
            USERS: 'users',
            ACCOUNT_COMPANIES: 'account_companies',
            COMPANY_SUMMARY: 'company_summary',
            RECEIPTS: 'receipts',
            CONNECTED_SERVICES: 'connected_service',

            PRESENCE_SOCIAL_POSTS: 'presence_social_posts',
            MEDIA_WIDGET: 'media_widget',
            SOCIAL_POSTS: 'social_posts',
            FOCUS_COMPANY_SOCIAL_POSTS: 'focus_company_social_posts',
            SOCIAL_POSTS_GLANCE: 'social_posts_glance',
            SOCIAL_POSTS_TRENDS: 'social_posts_trends',
            SOCIAL_POSTS_HASHTAG_USAGE: 'social_posts_hashtag_usage',
            SOCIAL_POSTS_HASHTAG_USAGE_TABLE: 'social_posts_hashtag_usage_table',
            SOCIAL_POSTS_TIME_USAGE: 'social_posts_time_usage',
            SOCIAL_POSTS_ACTIVITY: 'social_posts_activity',
            SOCIAL_POSTS_DIMENSION_ANALYSIS: 'social_posts_dimension_analysis',
            SOCIAL_POSTS_HASHTAG_TABLE: 'social_posts_hashtag_table',
            SOCIAL_POSTS_SHARED_DOMAIN_TABLE: 'social_posts_shared_domain_table',
            SOCIAL_POSTS_SHARED_URLS_BY_COMPANY_TABLE: 'social_posts_shared_urls_by_company_table',
            SOCIAL_POSTS_LINKS_POSTED_TABLE: 'social_posts_links_posted_table',
            SOCIAL_POSTS_KEYWORDS_TABLE: 'social_posts_keywords_table',
            SOCIAL_POSTS_BOOSTED_POSTS_TABLE: 'social_posts_boosted_posts_table',
            SOCIAL_POSTS_LINKS_SHARED_OBSERVATIONS: 'social_posts_links_shared_observations',
            SOCIAL_POSTS_LINKS_POSTED_OWNED_VS_CURATED_TABLE: 'social_posts_links_posted_owned_vs_curated_table',
            SOCIAL_POSTS_POST_TAGS_TABLE: 'social_posts_post_tags_table',
            SOCIAL_POSTS_POST_AGGREGATES_TABLE: 'social_posts_post_aggregates_table',
            POST_TAGS_LIST: 'post_tags_list',

            // summer 2020 release widgets
            OVERVIEW_TOP_POSTS: 'overview_top_posts',
            OVERVIEW_SINGLE_CHANNEL_TOP_POSTS: 'overview_single_channel_top_posts',
            OVERVIEW_CROSS_CHANNEL_TOP_POSTS: 'overview_cross_channel_top_posts',
            OVERVIEW_LANDSCAPE_COMPARISON: 'overview_landscape_comparison',

            RANKED_KEYWORDS: 'ranked_keywords',
            CHANGED_KEYWORDS: 'changed_keywords',
            KEYWORDS_TRAFFIC: 'keywords_traffic',
            KEYWORDS_TABLE: 'keywords_table',
            COMPANY_KEYWORDS_DETAILS: 'company_keywords_details',
            COMPANY_KEYWORDS: 'company_keywords',
            IN_COMMON_KEYWORDS: 'in_common_keywords',
            IN_COMMON_KEYWORDS_DETAILS: 'in_common_keywords_details',
            VALUE_KEYWORDS: 'value_keywords',

            COMPANY_CHANNEL: 'company_channel',
            COMPANY: 'company',
            SECTIONAL: 'sectional',

            BUILDER: 'builder'
        };

        exports.widgetGroupType = {
            CHART: 'chart',
            LIST: 'lists',
            COMPOSITE: 'composite',
            INSTAGRAM_INSIGHTS_POSTS: 'instagram-insights-posts',
            INSTAGRAM_INSIGHTS_STORIES: 'instagram-insights-stories',
            INSTAGRAM_INSIGHTS_STORYDAYS: 'instagram-insights-storydays'
        };

        exports.widgetGroupTitle = {};
        exports.widgetGroupTitle[exports.widgetGroupType.CHART] = 'Chart';
        exports.widgetGroupTitle[exports.widgetGroupType.LIST] = 'Widget';
        exports.widgetGroupTitle[exports.widgetGroupType.INSTAGRAM_INSIGHTS_POSTS] = 'Widget';
        exports.widgetGroupTitle[exports.widgetGroupType.INSTAGRAM_INSIGHTS_STORIES] = 'Widget';
        exports.widgetGroupTitle[exports.widgetGroupType.INSTAGRAM_INSIGHTS_STORYDAYS] = 'Widget';

        exports.widgetSize = {
            THIRD_PAGE: 'medium',
            FULL_PAGE: 'full-page'
        };

        exports.widgetFocusCompanyTitlePlacement = {
            PREFIX: 'prefix',
            SUFFIX: 'suffix',
            NONE: 'none'
        };
    }

})();
